import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import clsx from "clsx";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { showNavbar } from "../../store/modules/appStateSlice";
import SecondaryMenu from "../shared/SecondaryMenu";
import Alert from "@material-ui/lab/Alert";
import {
  IconButton,
  Button,
  LinearProgress,
  CircularProgress,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Checkbox
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";
import ErrorTryAgain from "../shared/ErrorTryAgain/ErrorTryAgain";
import DeletePopUp from "../shared/DeletePopUp";
import { VehicleType } from "./types";
import api from "../../store/api";
import { RootState } from "../../store/rootReducer";
import { consts } from "../../common/consts";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "stretch",
    flexGrow: 1,
  },
  leftMenu: {
    alignSelf: "stretch",
    display: "flex",
  },
  main: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "40px 40px 24px 40px",
  },
  backBtn: {
    backgroundColor: "transparent",
    fontWeight: 700,
    color: "#02489D",
    fontSize: "18px",

    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  backBtnText: {
    marginLeft: "8px",
  },
  deleteBtn: {
    float: "right",
  },
  content: {
    display: "flex",
    flex: "1",
    position: "relative",
    padding: "0 40px",
    flexDirection: "column",
  },
  title: {
    fontSize: "36px",
    fontWeight: 900,
    margin: "0 0 33px 0",
    padding: 0,
  },
  subTitle: {
    fontSize: "18px",
    fontWeight: 700,
    padding: 0,
    marginTop: 10
  },
  titleArea: {
    margin: "0 0 33px 0",
  },
  alerts: {},
  headingAlert: {
    padding: 10,
  },
  loading: {
    width: "calc(100% - 80px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    position: "absolute",
    height: "100%",
  },
  error: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  saving: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  formBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: "100px",
    height: "40px",
  },
  formLeft: {
    paddingLeft: 40,
    paddingBottom: 40,
    paddingTop: 40,
  },
  divider: {
    height: 0,
    borderTop: "1px solid #979797",
  },
  textFieldLable: {
    fontSize: 15,
    color: "#949494",
    fontWeight: "bold",
    padding: theme.spacing(0, 0, 1, 0),
  },
  formBlock: {
    marginBottom: 25,
  },
  formItemBlock: {
    marginBottom: 5,
  },
  fixedWidth: {
    width: 238,
  },
  formSelect: {},
  textFieldRoot: {
    width: "100%",
  },
  textFieldInput: {
    backgroundColor: "#ECECEC",
    color: "black",
    height: "40px",
  },
  callSignBlock: {
    display: "flex",
    alignItems: "center",
  },
  callSignPrefix: {
    fontSize: "18px",
    fontWeight: 900,
    marginRight: "11px",
  },
  alertRoot: {
    marginTop: 24,
  },
}));

const NUMBER_OF_ATTENDANT_SEATS = [1, 2, 3, 4];
const NUMBER_OF_ATTENDANT_STRETCHERS = [1, 2, 3, 4];

const EditVehiclePage = (): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();
  const style = useStyles();
  const { vehicleId } = useParams<{ vehicleId: string }>();
  const isEditItem = !!vehicleId;
  const { customerId } = useParams<{ customerId: string }>();
  const [customer,setCustomer]=useState(customerId);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isError, setIsError] = useState(false); // initial load
  const [errorMessage, setErrorMessage] = useState(""); // save, delete
  const [successMessage, setSuccessMessage] = useState(""); // save, delete
  const [vehicleInfo, setVehicleInfo] = useState<VehicleType>({});
  const errorView = useRef<null | HTMLDivElement>(null);

  const { authStore } = useSelector((state: RootState) => state);
  const [isAdmin, setIsAdmin] = React.useState<any>(authStore?.data?.IsAdmin || authStore.data?.role.split(",").includes(consts.Permissions.SMAAdminManageVehicles));

  useEffect(() => {
    dispatch(showNavbar(true));
  }, []);

  useEffect(() => {
    if (isEditItem) {
      setIsLoading(true);
      setIsError(false);
      api
        .getVehicle(`vehicleId=${vehicleId}`)
        .then((res) => {
          setVehicleInfo(_.get(res, "data.model"));
          setCustomer(res.data.model.fleetOfCustomer);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsError(true);
          setIsLoading(false);
        });
    }
    else{
      if (isAdmin){
        setIsLoading(true);
        setIsError(false);
        api
          .initializeNewVehicle("?customerOrLocationID=" +customerId + "&isLocationId=false")
          .then((res) => {
            setVehicleInfo(_.get(res, "data.model"));
            setIsLoading(false);
          })
          .catch((error) => {
            setIsError(true);
            setIsLoading(false);
          });
      }
      else{
        setIsLoading(true);
        setIsError(false);
        api
          .initializeNewVehicle("?customerOrLocationID=" +customerId + "&isLocationId=true")
          .then((res) => {
            setVehicleInfo(_.get(res, "data.model"));
            setIsLoading(false);
          })
          .catch((error) => {
            setIsError(true);
            setIsLoading(false);
          });
      }
    }
  }, []);

  const saveAction = async () => {
    setIsSaving(true);
    setErrorMessage("");
    setSuccessMessage("");

    if (isEditItem) {
      const payload = {
        vehicleId: vehicleInfo.vehicleId,
        baseId: vehicleInfo.baseId,
        callSign: vehicleInfo.callSign,
        noOfAttendantSeats: vehicleInfo.noOfAttendantSeats,
        noOfStretchers: vehicleInfo.noOfStretchers,
        acuity: vehicleInfo.acuity,
        suitableForHealthshare: vehicleInfo.suitableForHealthshare,
        callSignPrefix: vehicleInfo.callSignPrefix,
        fleetOfCustomer: vehicleInfo.fleetOfCustomer,
        fleetOfCustomerName: vehicleInfo.fleetOfCustomerName,
        acuityB: vehicleInfo.acuityB,
        acuityC: vehicleInfo.acuityC,
        acuityD: vehicleInfo.acuityD,
        acuityE: vehicleInfo.acuityE,
        acuityL: vehicleInfo.acuityL,
        acuityM: vehicleInfo.acuityM,
        acuityH: vehicleInfo.acuityH
      };
      api
        .updateVehicle("", payload)
        .then((res) => {
          const isError = _.get(res, "hasError");
          if (isError) {
            setErrorMessage(res?.message);
          } else {
            setSuccessMessage(res?.message);
          }
          setIsSaving(false);
        })
        .catch((error) => {
          setErrorMessage("There was a error, please try again");
          setIsSaving(false);
        });
    } else {
      const payload = {
        callSign: vehicleInfo.callSign,
        noOfAttendantSeats: vehicleInfo.noOfAttendantSeats,
        noOfStretchers: vehicleInfo.noOfStretchers,
        acuity: vehicleInfo.acuity,
        suitableForHealthshare: vehicleInfo.suitableForHealthshare,
        callSignPrefix: vehicleInfo.callSignPrefix,
        fleetOfCustomer: vehicleInfo.fleetOfCustomer,
        fleetOfCustomerName: vehicleInfo.fleetOfCustomerName,
        acuityB: vehicleInfo.acuityB,
        acuityC: vehicleInfo.acuityC,
        acuityD: vehicleInfo.acuityD,
        acuityE: vehicleInfo.acuityE,
        acuityL: vehicleInfo.acuityL,
        acuityM: vehicleInfo.acuityM,
        acuityH: vehicleInfo.acuityH
      };
      api
        .addVehicle("", payload)
          .then((res) => {
              const isError = _.get(res, "hasError");
              let mess = res?.message;
              if (isError) {                  
                  setErrorMessage(mess ?? '');
              } else {
                  setSuccessMessage(mess ?? '');
              }
              setIsSaving(false);
          })
        .catch((error) => {
          setErrorMessage("There was a error, please try again");
          setIsSaving(false);
        });
    }
  };

  const executeScroll = () => {
    if (errorView && errorView.current){
      errorView.current.scrollIntoView();
    }
  }

  const deleteAction = async () => {
    if (isEditItem) {
      setIsLoading(true);
      setErrorMessage("");
      setSuccessMessage("");
      const payload = {
        callSign: vehicleInfo.callSign,
        vehicleId: vehicleInfo.vehicleId,
        deleted: true,
      };
      api
        .updateVehicle("", payload)
        .then((res) => {
          const isError = _.get(res, "hasError");
          if (isError) {
            setIsLoading(false);
            setErrorMessage(res?.message);
            setConfirmationDialog(false);
            executeScroll();
          } else {
            backToVehiclesList();
          }
        })
        .catch((error) => {
          setErrorMessage("There was a error, please try again");
          setIsLoading(false);
        });
    }
  };

  const backToVehiclesList = () => {
    if(isAdmin)
      history.push({
        pathname: `/settings/vehicles/${customer}`,
      });
    else
      history.push({
        pathname: "/managevehicles",
      });
  };

  if (isLoading) {
    return (
      <div className={style.loading}>
        <CircularProgress />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={style.error}>
        <ErrorTryAgain noBackground={true} />
      </div>
    );
  }

  return (
    <div className={style.root}>
      {isAdmin ?(<div className={style.leftMenu}>
        <SecondaryMenu selectedmenu={"Vehicles"} />
      </div>):""}
      <div className={style.main}>
        <div className={style.heading}>
          <IconButton className={style.backBtn} onClick={backToVehiclesList} size="small">
            <ArrowBackIcon fontSize="small" />
            <span className={style.backBtnText}>Vehicles</span>
          </IconButton>
          {isEditItem && (
            <Button className={style.deleteBtn} variant="contained" onClick={() => setConfirmationDialog(true)}>
              Delete
            </Button>
          )}
        </div>
        <div className={style.content}>
        <div className={style.titleArea}>
          <div className={style.title}>{isEditItem ? `Vehicle ${vehicleInfo.callSign}` : "Add new vehicle"}</div>
          <div className={style.subTitle}>{vehicleInfo.fleetOfCustomerName}</div>
        </div>
          <div className={clsx(style.formBlock, style.fixedWidth)}>
            <div className={style.textFieldLable}>VEHICLE CALLSIGN</div>
            <div className={style.callSignBlock}>
              {/* Commenting the below field as per the instruction from Shane. Uncomment it if needed*/}
              {/*{vehicleInfo.callSignPrefix ?*/}
              {/*<span className={style.callSignPrefix}>{vehicleInfo.callSignPrefix}</span>*/}
              {/*:""} */}
              <TextField
                InputProps={{ classes: { root: style.textFieldInput } }}
                variant="outlined"
                value={vehicleInfo.callSign}
                onChange={(e) =>
                  {if (e.target.value.toString().length <= 6) {
                  setVehicleInfo((v) => {
                    return {
                      ...v,
                      callSign: String(e.target.value),
                    };
                  })
                }
                }}
              />
            </div>
          </div>

          <div className={clsx(style.formBlock, style.fixedWidth)}>
            <div className={style.textFieldLable}>NUMBER OF ATTENDANT SEATS</div>
            <Select
              onChange={(e) =>
                setVehicleInfo((v) => {
                  return {
                    ...v,
                    noOfAttendantSeats: Number(e.target.value),
                  };
                })
              }
              className={style.formSelect}
              fullWidth={true}
              value={vehicleInfo?.noOfAttendantSeats}
              displayEmpty
              IconComponent={KeyboardArrowDownIcon}
              defaultValue=""
              variant="outlined"
            >
              {NUMBER_OF_ATTENDANT_SEATS.map((item) => (
                <MenuItem selected={item === vehicleInfo?.noOfAttendantSeats} key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div className={clsx(style.formBlock, style.fixedWidth)}>
            <div className={style.textFieldLable}>NUMBER OF STRETCHERS</div>
            <Select
              onChange={(e) =>
                setVehicleInfo((v) => {
                  return {
                    ...v,
                    noOfStretchers: Number(e.target.value),
                  };
                })
              }
              className={style.formSelect}
              fullWidth={true}
              value={vehicleInfo?.noOfStretchers}
              displayEmpty
              IconComponent={KeyboardArrowDownIcon}
              defaultValue=""
              variant="outlined"
            >
              {NUMBER_OF_ATTENDANT_STRETCHERS.map((item) => (
                <MenuItem selected={item === vehicleInfo?.noOfStretchers} key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div className={style.formBlock}>
            <div className={style.textFieldLable}>ACUITY</div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="B"
                control={
                  <Checkbox
                    defaultChecked={vehicleInfo?.acuityB ? vehicleInfo?.acuityB:false}
                    disabled={false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityB: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="C"
                control={
                  <Checkbox
                    defaultChecked={vehicleInfo?.acuityC ? vehicleInfo?.acuityC:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityC: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="D"
                control={
                  <Checkbox
                  defaultChecked={vehicleInfo?.acuityD ? vehicleInfo?.acuityD:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityD: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="E"
                control={
                  <Checkbox
                  defaultChecked={vehicleInfo?.acuityE ? vehicleInfo?.acuityE:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityE: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="Low"
                control={
                  <Checkbox
                  defaultChecked={vehicleInfo?.acuityL ? vehicleInfo?.acuityL:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityL: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="Medium"
                control={
                  <Checkbox
                  defaultChecked={vehicleInfo?.acuityM ? vehicleInfo?.acuityM:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityM: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
            <div className={style.formItemBlock}>
              <FormControlLabel
                label="High"
                control={
                  <Checkbox
                  defaultChecked={vehicleInfo?.acuityH ? vehicleInfo?.acuityH:false}
                    onChange={(e) =>
                      setVehicleInfo((v) => {
                        return {
                          ...v,
                          acuityH: Boolean(e.target.checked),
                        };
                      })
                    }
                  />
                }
              />
            </div>
          </div>
          {vehicleInfo.isSMAVehicle===true ?(<div className={style.formBlock}>
            <div className={style.textFieldLable}>SUITABLE FOR HEALTHSHARE SHIFTS?</div>
            <RadioGroup
              row
              name="Shift"
              value={String(vehicleInfo?.suitableForHealthshare)}
              onChange={(e) =>
                setVehicleInfo((v) => {
                  return {
                    ...v,
                    suitableForHealthshare: e.target.value === "true",
                  };
                })
              }
            >
              <FormControlLabel value={"true"} control={<Radio color="primary" />} label="Yes" />
              <FormControlLabel value={"false"} control={<Radio color="primary" />} label="No" />
            </RadioGroup>
          </div>):""}

          <div className={style.alerts}>
            <div className={style.headingAlert} ref={errorView}>
              {errorMessage && (
                <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: style.alertRoot }}>
                  {errorMessage}
                </Alert>
              )}

              {successMessage && (
                <Alert variant="filled" icon={<InfoIcon />} severity="success" classes={{ root: style.alertRoot }}>
                  {successMessage}
                </Alert>
              )}
            </div>
          </div>
        </div>

        <div>
          {isSaving ? (
            <div className={style.saving}>
              <LinearProgress color="primary" />
            </div>
          ) : (
            <hr className={style.divider} />
          )}
        </div>

        <div className={style.formLeft}>
          <Button disabled={isSaving} className={style.formBtn} variant="contained" color="primary" onClick={saveAction}>
            {isEditItem ? "Save" : "Add vehicle"}
          </Button>
          <Button className={style.formBtn} variant="contained" onClick={backToVehiclesList}>
            Cancel
          </Button>
        </div>

        <DeletePopUp
          isDialogOpen={confirmationDialog}
          onCancel={() => setConfirmationDialog(false)}
          onDo={deleteAction}
          title="Delete vehicle"
          recordName="vehicle"
        />
      </div>
    </div>
  );
};

export default EditVehiclePage;
